(function ($, document, window) {
	'use strict';

	$(function () {
		$('.js-related-products-carousel').each(function () {
			const carousel = $(this);
			const sliderEl = $('.swiper', carousel)[0];
			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 10,
				slidesPerView: 1,
				loop: true,

				navigation: {
					nextEl: $('.js-carousel-nav-next', carousel)[0],
					prevEl: $('.js-carousel-nav-prev', carousel)[0],
				},

				breakpoints: {
					460: {
						slidesPerView: 2,
					},
					580: {
						slidesPerView: 3,
					},
					744: {
						slidesPerView: 4,
					},
					1024: {
						slidesPerView: 5,
					},
					1280: {
						slidesPerView: 6,
					},
				},
			});
		});
	});
})(jQuery, document, window);
